import { useAppContext } from "app/AppContext";
import firebaseUtil from "firebaseUtil";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserUid } from "useAuth";

import Home from "./Home";

import RoutesMenusLaudoVisita from "./LaudoVisita";
import RoutesMenusCliente from "./Cliente";
import RoutesMenusControle from "./Controle";
import RoutesMenusFazenda from "./Fazenda";
import RoutesMenusUsuario from "./Usuario";
import RoutesMenusCultura from "./Cultura";
import RoutesMenusVariedade from "./Variedade";
import RoutesMenusSafra from "./Safra";
import RoutesMenusInsumo from "./Insumo";
import RoutesMenusImplemento from "./Implemento";
import RoutesMenusTrator from "./Trator";
import RoutesMenusMapa from "./Mapa";
import RoutesMenusExclusaoDados from "./ExclusaoDados";
import RoutesMenusFrente from "./Frente";
import RoutesMenusEquipamento from "./Equipamento";
import RoutesMenusPoliticaPrivacidade from "./PoliticaPrivacidade";
import RoutesMenusAtualizacaoMassa from "./AtualizacaoLaudosEmMassa";
import RoutesMenusOperador from "./Operador";

export default function RoutesMenusPrivate() {
    const navigate = useNavigate();

    const isAuthenticated = useUserUid();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    useEffect(() => {
        if (isAuthenticated) {
            addMenu({
                uid: "Inicio",
                text: "Início",
                iconName: "Home",
                sequence: "0",
                action: () => {
                    navigate("/");
                },
            });
            addRoute({ uid: "homeauth", title: "Início", route: "/", element: <Home /> });
            addMenu({
                uid: "sair",
                text: "Sair",
                iconName: "ExitToApp",
                sequence: "999999",
                action: async () => {
                    await firebaseUtil.logout();
                    navigate("/login");
                },
            });
        }
        return () => {
            // console.log("remove buttoms private");
            removeMenusRoutes(["Inicio", "homeauth", "sair"]);
            // removeMenusRoutes(["Inicio", "homeauth", "sair", "parentCadastros", "ConsultaVisitasRelatorios", "Cadastros", "Grupo Permissão"]);
        };
    }, [addMenu, addRoute, isAuthenticated, navigate, removeMenusRoutes]);

    if (!isAuthenticated) {
        return "";
    }

    return (
        <>
            <RoutesMenusControle />
            <RoutesMenusLaudoVisita />
            <RoutesMenusCliente />
            <RoutesMenusMapa />
            <RoutesMenusFazenda />
            <RoutesMenusUsuario />
            <RoutesMenusCultura />
            <RoutesMenusVariedade />
            <RoutesMenusSafra />
            <RoutesMenusInsumo />
            <RoutesMenusImplemento />
            <RoutesMenusTrator />
            <RoutesMenusFrente />
            <RoutesMenusEquipamento />
            <RoutesMenusOperador />
            <RoutesMenusExclusaoDados />
            <RoutesMenusPoliticaPrivacidade />
            <RoutesMenusAtualizacaoMassa />
        </>
    );
}
